module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('draggable', {
    staticClass: "list-group dropArea",
    class: !_vm.schema.length ? 'empty' : '',
    attrs: {
      "tag": "ul",
      "list": _vm.schema,
      "group": {
        name: 'components'
      },
      "data-content": "Drag and drop your fields here."
    },
    on: {
      "add": _vm.addItem
    }
  }, _vm._l((_vm.schema), function(item, index) {
    return _c('li', {
      key: ("drag-item-" + (item.name)),
      class: 'list-group-item col-md-' + item.grid
    }, [(_vm.componentsMapping[item.type]) ? _c(_vm.componentsMapping[item.type], {
      tag: "component",
      attrs: {
        "item": item,
        "show-share-with-participant": !['row', 'divider'].includes(item.type),
        "show-is-shared": !['row', 'divider'].includes(item.type),
        "id": _vm.id,
        "shared-fields": _vm.sharedFields
      },
      on: {
        "duplicate": function($event) {
          return _vm.duplicateField($event, index)
        },
        "remove": function($event) {
          return _vm.removeField($event, index)
        },
        "toggle": function($event) {
          return _vm.toggleField(item, $event)
        },
        "field-removed": function($event) {
          return _vm.$emit('field-removed', item.name)
        }
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-369ac5c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/VueFormEditor.vue
// module id = 1606
// module chunks = 1